module.exports = __webpack_public_path__ + "static/20200301_213720_optimized-eb93196c11f0b4a445ca7f5ad9a1e629.jpg";